import { Box } from '@mui/material'
import { ActionItem } from './action-item'
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined'
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'

import PlusIconRounded from 'src/assets/icons/v2/PlusIconRounded'

import { useStyles } from '../styles'
import { useNavigate } from 'react-router-dom'
import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'
import { useCommonSettings } from 'src/hooks'
import TraicyAgentIcon from 'src/assets/icons/v2/TraicyAgentIcon'

export const ActionList = () => {
  const navigate = useNavigate()

  const { data: settings } = useCommonSettings()

  const classes = useStyles()

  const handleNavigate = (path: string) => navigate(path)

  return (
    <Box className={classes.actionsContainer}>
      <ActionItem
        actionText={'Scan-To-Earn'}
        actionSupText={'ALPHA'}
        description={
          'Scan product barcodes to learn more about a product, provide valuable information, and to earn $TRAI tokens.'
        }
        buttonText={'Scan-To-Earn'}
        disabled={!settings?.scan_to_earn_enabled}
        icon={<PlusIconRounded size="28px" />}
        handleClick={handleNavigate.bind(null, joinAbsRoute(ROUTES.USER, ROUTES.SCAN_TO_EARN))}
      />
      <ActionItem
        actionText={'Challenges'}
        description={
          'View the latest challenges to earn bonus $TRAI tokens and climb the leaderboard!'
        }
        buttonText={'Challenges'}
        disabled={false}
        icon={<TaskAltOutlinedIcon sx={{ width: '28px', height: '28px' }} />}
        handleClick={handleNavigate.bind(null, joinAbsRoute(ROUTES.USER, ROUTES.CHALLENGES_USER))}
      />

      <ActionItem
        actionText={'Leaderboard'}
        description={
          'Complete challenges and scan product barcodes to climb the ranks! Click here to see where you stand against fellow Trackgood members! The top 10 ranks earn prizes.'
        }
        buttonText={'Leaderboard'}
        disabled={false}
        icon={<BarChartOutlinedIcon sx={{ width: '28px', height: '28px' }} />}
        handleClick={handleNavigate.bind(null, joinAbsRoute(ROUTES.USER, ROUTES.LEADERBOARD))}
      />

      <ActionItem
        actionText={'Traicy Agent'}
        description={
          'Meet Traicy, your AI-powered guide on sustainability, trained to provide insights on ethical choices and support brands on their ESG journey.'
        }
        buttonText={'TRAICY'}
        disabled={false}
        icon={<TraicyAgentIcon size="28px" />}
        handleClick={handleNavigate.bind(null, joinAbsRoute(ROUTES.USER, ROUTES.TRAICY_CHATBOT))}
      />
    </Box>
  )
}
